import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    ConfirmDialogData,
    ConfirmDialogResult,
} from '../../../../../common-modules/components/components/confirm-dialog/confirm-dialog.component';
import { AuthService } from '../../services/auth.service';
import { UsersService } from '../../../users/services/users.service';
import { SecurityaddonsService } from '../../../securityaddons/services/securityaddons.service';
import { ToastService } from '../../../../../common-modules/services/toast.service';
import { Router } from '@angular/router';
import { MdrDashboardsService } from '../../../mdr-dashboards/services/mdr-dashboards.service';
import { FeatureFlagsService } from '../../../../services/feature-flags.service';
import { IdentityService } from '../../services/identity.service';

export enum TCSteps {
    TC = 0,
    BREACH = 1,
}

@Component({
    selector: 'app-tc-dialog',
    templateUrl: './tc-dialog.component.html',
    styleUrls: ['./tc-dialog.component.scss'],
    standalone: false,
})
export class TcDialogComponent implements OnInit {
    public isLoading = false;
    public stepsAccepted: number;
    public currentStep: TCSteps = TCSteps.TC;
    public steps = TCSteps;
    public CancelResult = {
        chosePrimary: false,
        choseSecondary: false,
        choseCancel: true,
    } as ConfirmDialogResult;
    public showProgressBar: boolean = true;
    public tcUrl: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
        public dialogRef: MatDialogRef<TcDialogComponent>,
        public authService: AuthService,
        public identityService: IdentityService,
        public userService: UsersService,
        public securityAddOnService: SecurityaddonsService,
        public toastService: ToastService,
        public router: Router,
        public mdrDashboardsService: MdrDashboardsService,
        public featuresFlag: FeatureFlagsService,
    ) {}

    public acceptTc() {
        if (this.authService.jwtUser === null) {
            return;
        }

        this.isLoading = true;
        this.dialogRef.disableClose = true;
        if (this.currentStep === TCSteps.TC) {
            this.userService.acceptTermsAndConditions(this.authService.jwtUser.UserId).subscribe((result) => {
                this.onSuccess();
                localStorage.setItem('acceptedTC', 'true');
            });
        }
    }

    public onSuccess() {
        this.isLoading = false;
        this.dialogRef.disableClose = false;

        this.dialogRef.close();
        this.router.navigate(['dashboard/browse']);
        this.toastService.showSuccess($localize`Terms and Conditions accepted.`, {
            duration: 5000,
        });
    }

    ngOnInit(): void {
        this.tcUrl = this.featuresFlag.get('terms_and_conditions_url');
        this.stepsAccepted = 0;

        const user = this.authService.jwtUser;

        if (user && user.meta.termsAndConditionsAccepted) {
            this.router.navigate(['dashboard/browse']).catch(console.error);
        }
    }

    declineTc() {
        location.reload();
    }

    public isPremium() {
        return this.mdrDashboardsService.isPremiumEnterprise(this.identityService.company);
    }
}
